import {
  FETCH_ACTION,
  RECEIVE_ACTION,
  ERROR_ACTION,
  AUTH_ERROR_ACTION
} from "../action/identity";

export default (state = {}, { type, ...params }) => {
  switch (type) {
    case FETCH_ACTION:
      return {
        ...state,
        isFetching: true
      };
    case RECEIVE_ACTION:
      const { role, employeeInfo, profile, ...identity } = params;
      const theatre = (employeeInfo || {}).theatre || {};
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        ...identity,
        employeeInfo: employeeInfo || null,
        profile: profile || null,
        name: (profile && profile.name) || identity.username,
        position: (role || []).includes("ADMIN") ? "admin" : "user",
        city: (profile && profile.city) || null,
        theatreId: theatre.id || null,
        theatreCityId: (theatre.city || {}).id || null
      };
    case ERROR_ACTION:
      return {
        isFetched: false,
        isFetching: false,
        hasError: true,
        ...params
      };
    case AUTH_ERROR_ACTION:
      return {
        isFetched: false,
        isFetching: false,
        hasAuthError: true,
        ...params
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducer/identity.js